import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fields" }

import { computed, ref, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { showError } from '@services/utils/dialog';

import NcButton from '@nextcloud/vue/components/NcButton';
import NcTextField from '@nextcloud/vue/components/NcTextField';

import Modal from './Modal.vue';

import { useModal } from '@services/modal';
import { t } from '@services/l10n';
import { useRouteIs } from '@services/route-is';
import { isAbortError, useAbort } from '@services/utils/abort-vue';
import * as utils from '@services/utils/common';
import * as dav from '@services/dav';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'FaceEditModal',
},
  __name: 'FaceEditModal',
  setup(__props, { expose: __expose }) {



const route = useRoute();
const router = useRouter();
const routeIs = useRouteIs();
const modal = useTemplateRef('modal');
const { show, close } = useModal(modal);
const rawInput = ref(String());
const saving = ref(false);
const abort = useAbort();

const name = computed(() => route.params.name?.toString());
const user = computed(() => route.params.user?.toString());

const input = computed(() => {
  // Prevent leading and trailing spaces in name
  // https://github.com/pulsejet/memories/issues/1074
  return rawInput.value.trim();
});

const canSave = computed(
  () => input.value && name.value !== input.value && isNaN(Number(input.value)) && !saving.value,
);

function open() {
  if (user.value !== utils.uid) {
    showError(t('memories', 'Only user "{user}" can update this person', { user: user.value }));
    return;
  }

  rawInput.value = isNaN(Number(name.value)) ? (name.value ?? String()) : String();
  show.value = true;
}

function cleanup() {
  abort.abort();
  show.value = false;
  saving.value = false;
}

async function save() {
  if (!canSave.value || saving.value) return;
  saving.value = true;
  const signal = abort.renew();

  try {
    if (routeIs.Recognize) {
      await dav.recognizeRenameFace(user.value, name.value, input.value, { signal });
    } else {
      await dav.faceRecognitionRenamePerson(name.value, input.value, { signal });
    }
    signal.throwIfAborted();

    await close();
    await router.replace({
      name: route.name?.toString(),
      params: { user: user.value, name: input.value },
    });
  } catch (error) {
    if (isAbortError(error)) return;
    console.error(error);
    showError(
      t('memories', 'Failed to rename {oldName} to {name}.', {
        oldName: name.value,
        name: input.value,
      }),
    );
  } finally {
    if (!signal.aborted) saving.value = false;
  }
}

__expose({ open });

return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createBlock(Modal, {
        key: 0,
        ref_key: "modal",
        ref: modal,
        onClose: cleanup
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('memories', 'Rename person')), 1)
        ]),
        buttons: _withCtx(() => [
          _createVNode(_unref(NcButton), {
            class: "button",
            variant: "primary",
            disabled: !canSave.value,
            onClick: save
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('memories', 'Update')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(NcTextField), {
              class: "field",
              autofocus: true,
              modelValue: rawInput.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rawInput).value = $event)),
              label: _unref(t)('memories', 'Name'),
              "label-visible": false,
              placeholder: _unref(t)('memories', 'Name'),
              onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (save()), ["enter"]))
            }, null, 8, ["modelValue", "label", "placeholder"])
          ])
        ]),
        _: 1
      }, 512))
    : _createCommentVNode("", true)
}
}

})